import { render } from "./InputDraw.vue?vue&type=template&id=eb111728"
import script from "./InputDraw.vue?vue&type=script&lang=js"
export * from "./InputDraw.vue?vue&type=script&lang=js"

import "./InputDraw.vue?vue&type=style&index=0&id=eb111728&lang=css"
script.render = render

export default script